export default __webpack_public_path__ + "static/media/litho-demo-blog-post-layout-01.a13756f8.jpg";